import React, { useEffect, useState } from "react";
import DragDropChart from "../DragAndDrop";
import { useParams } from "react-router-dom";
import axios from "axios";
import { IoCaretDown, IoCaretUp } from "react-icons/io5";
import { TbArrowNarrowLeftDashed } from "react-icons/tb";
import { useGlobalContext } from "../../../context/context";
// import OrgChart  from '@dabeng/react-orgchart';
import { MdSubdirectoryArrowLeft } from "react-icons/md";

import "../org.css";
import Loading from "../../Loding/Loading";
import LawMinerSectionsAndChapters from "./LawMinerSectionsAndChapters";
import LawMinerPlusSectionAndChapters from "./LawMinerPlusSectionAndChapters";
import CreateNewSubjectTree from "./CreateNewSubjectTree";
// import VerticalTree from './NewOrganization/NewCharts';
import { BsPlusSquareFill } from "react-icons/bs";
const SectionsAndChapters = () => {
  const [tdata, setData] = useState([]);
  const params = useParams();
  const [loading, setLoading] = useState(false);
  const [EditView, setEditView] = useState(false);
  const {NewSubject, setNewSubject ,currentuser} = useGlobalContext()
  const [treeView, setTreeView] = useState(true);
  useEffect(() => {
      window.scrollTo(0, 0);
      
      return () => {};
    }, []);
  useEffect(() => {
    setLoading(true);
    const fetchData = async () => {
      try {
        const result = await axios(
          `${
            process.env.REACT_APP_BASE_URL
          }/api/Data/SubjectsTree?tabvib=true&addroot=true${
            params.id === null ? "" : "&parent=" + params.id
          }`
        );
        setData(result.data);
        // const x = result.data.find((i) => i.children.length > 0);
        // if (x !== undefined) {
        //   setRecordID(x.id);
        // }

        // console.log('result.data', result.data);
        setLoading(false);
      } catch (error) {
        console.log("errorfetchDataSubjectsTree", error);
        // setLoading(false);
      }
    };

    fetchData();

    // return () => {};
  }, []);
  // const clickEditBtn=()=>{

  // }
  // const clickViewBtn=()=>{

  // }
  // console.log(currentuser)
  return (
    <div className="mt-48 w-[90%] pt-5  pb-32 mb-20 h-auto  bg-white border-2 rounded-lg flex flex-col rtl">
      <h1 className="text-center mb-3 font-bold text-IranSans text-[18px]">
        {tdata.name + " " + tdata.title}
      </h1>
      {/* { currentuser !==null && currentuser.role === "Connoisseur" ? <div className="flex items-center justify-between w-full ">
     
        <div className="flex items-center  w-full px-5">
        <button
          onClick={() => {
            setTreeView(!treeView);setEditView(!EditView);setNewSubject(false);
          }}
          className={
            treeView
              ? "text-[14px] py-2 px-3 rounded-sm bg-[#009087] text-[#ffffff]"
              : "button2ForTab"
          }
        >
          حالت نمایشی
        </button>
        <button
          onClick={() => {
            setTreeView(!treeView);setEditView(!EditView);setNewSubject(false)
          }}
          className={
            EditView
              ? "text-[14px] py-2 px-3 rounded-sm bg-[#009087] text-[#ffffff]"
              : "button2ForTab"
          }
        >
          ویرایش درخت
        </button>
        </div>
       
        {EditView ? <div className="flex ltr items-center w-full px-5">
        <button
          onClick={() => {
            setTreeView(false);setNewSubject(!NewSubject)
          }}
          className={
            NewSubject
              ? "text-[14px] py-2 flex items-center px-3 rounded-sm bg-[#009087] text-[#ffffff]"
              : "button2ForTab"
          }
        >
          جدید 
          <BsPlusSquareFill className="ml-3"/>
        </button>
      </div>:<></>}
       
      </div>:<></>} */}
       <div className="flex items-center justify-between w-full ">
     
     <div className="flex items-center  w-full px-5">
     <button
       onClick={() => {
         setTreeView(!treeView);setEditView(!EditView);setNewSubject(false);
       }}
       className={
         treeView
           ? "text-[14px] py-2 px-3 rounded-sm bg-[#009087] text-[#ffffff]"
           : "button2ForTab"
       }
     >
       حالت نمایشی
     </button>
     <button
       onClick={() => {
         setTreeView(!treeView);setEditView(!EditView);setNewSubject(false)
       }}
       className={
         EditView
           ? "text-[14px] py-2 px-3 rounded-sm bg-[#009087] text-[#ffffff]"
           : "button2ForTab"
       }
     >
       ویرایش درخت
     </button>
     </div>
    
     {EditView ? <div className="flex ltr items-center w-full px-5">
     <button
       onClick={() => {
         setTreeView(false);setNewSubject(!NewSubject)
       }}
       className={
         NewSubject
           ? "text-[14px] py-2 flex items-center px-3 rounded-sm bg-[#009087] text-[#ffffff]"
           : "button2ForTab"
       }
     >
       جدید 
       <BsPlusSquareFill className="ml-3"/>
     </button>
   </div>:<></>}
   </div>
     <hr className="mt-[0.8px]"/>
      {treeView && <LawMinerSectionsAndChapters />}
      {NewSubject && <div className="px-5 "><CreateNewSubjectTree ID={params.id}/></div>}
      {EditView && <LawMinerPlusSectionAndChapters ID={params.id}/>}
    </div>
  );
};

export default SectionsAndChapters;
